import { useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import isEmail from 'validator/lib/isEmail';

import { SendOtpReq } from 'services/auth.service';
import { useAppDispatch } from 'store/store-hooks';
import { Path, useAuthNavigator } from 'components/_hooks/use-router';
import { sendOtp } from '../auth.slice';

import { Button } from 'components/UI/button/button';
import { InputGroup } from 'components/UI/input/input-group';
import { InputBase } from 'components/UI/input/elements/input-base';
import styles from '../_auth.module.scss';

export const AuthResetCode = () => {
  const { navigateTo } = useAuthNavigator();
  const [isPending, setIsPending] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SendOtpReq>();

  const onSubmit: SubmitHandler<SendOtpReq> = async (data) => {
    try {
      setIsPending(true);
      await dispatch(sendOtp(data)).unwrap();
      navigateTo(Path.resetPassword, `?email=${data.email}`);
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className={styles.Login}>
      <h3 className={styles.title}>Forgot password</h3>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <InputGroup header="Email" error={errors.email?.message}>
          <InputBase
            placeholder="Enter Email"
            {...register('email', {
              required: 'The Username is required',
              validate: (value) => isEmail(value) || 'The Email is invalid',
            })}
            alert={!!errors.email?.message}
          />
        </InputGroup>
        <Button disabled={isPending || !!Object.keys(errors).length}>Get Reset Code</Button>
      </form>
    </div>
  );
};
